import { motion } from 'framer-motion'
import { Cloud, Server, Lock, Database, Check } from 'react-feather'
import AnimatedBackground from '../common/AnimatedBackground'

import './ServiceDetail.css'

export default function CloudSolutions() {
  const technologies = [
    "AWS", "Azure", "Google Cloud", "Docker",
    "Kubernetes", "CI/CD", "Terraform", "Microservices"
  ]

  const features = [
    {
      icon: Cloud,
      title: "Cloud Migration",
      description: "Seamless transition of your infrastructure to the cloud."
    },
    {
      icon: Server,
      title: "DevOps",
      description: "Automated deployment and scaling solutions."
    },
    {
      icon: Lock,
      title: "Security",
      description: "Enterprise-grade security and compliance measures."
    },
    {
      icon: Database,
      title: "Data Management",
      description: "Efficient cloud storage and database solutions."
    }
  ]

  return (
    <section className="service-detail-section">
        <AnimatedBackground text="" />
      <div className="service-detail-container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="service-detail-header"
        >
          <h1>Cloud <span className="gradient-text">Solutions</span></h1>
          <p>Scalable and secure cloud infrastructure for modern businesses</p>
        </motion.div>

        <div className="service-content">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="service-description"
          >
            <h2>What We Offer</h2>
            <p>
              Our cloud solutions provide businesses with scalable, secure, and 
              cost-effective infrastructure. We help organizations leverage the 
              power of cloud computing to improve efficiency, reduce costs, and 
              accelerate innovation through modern DevOps practices and 
              cloud-native architectures.
            </p>
          </motion.div>

          <div className="features-grid">
            {features.map((feature, index) => {
              const Icon = feature.icon
              return (
                <motion.div
                  key={feature.title}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.8, delay: 0.4 + index * 0.1 }}
                  className="feature-card"
                >
                  <Icon className="feature-icon" />
                  <h3>{feature.title}</h3>
                  <p>{feature.description}</p>
                </motion.div>
              )
            })}
          </div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.8 }}
            className="technologies-section"
          >
            <h2>Technologies We Use</h2>
            <div className="technologies-grid">
              {technologies.map((tech, index) => (
                <div key={tech} className="technology-item">
                  <Check className="check-icon" />
                  <span>{tech}</span>
                </div>
              ))}
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 1 }}
            className="cta-section"
          >
            <h2>Ready to Move to the Cloud?</h2>
            <p>Let's discuss how we can help modernize your infrastructure.</p>
            <a href="/contact" className="cta-button">
              Get in Touch
            </a>
          </motion.div>
        </div>
      </div>
    </section>
  )
}

